export default function HostingSection() {
  const features = [
    'Keeping the website live and accessible',
    'Maintaining security and reliability',
    'Ensuring fast loading speeds',
    'Handling updates when needed',
  ];

  return (
    <section id="hosting" className="py-20 lg:py-32 bg-gradient-to-b from-black to-gray-950">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <div className="inline-block px-4 py-2 bg-white/5 border border-white/10 rounded-full mb-6">
            <span className="text-sm text-gray-300 font-medium">Nashville Web Hosting & Management</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-white mb-6 sm:mb-8">
            Website Hosting &amp; Management for Nashville Businesses
          </h2>
          <p className="text-base sm:text-lg text-gray-400 leading-relaxed mb-6">
            Once your Nashville website is built, it needs to be hosted online so customers can access it 24/7. <strong className="text-white">GWDevelopers provides professional website hosting in Nashville</strong> so business owners never have to deal with the technical side of keeping a website live.
          </p>
          <p className="text-base sm:text-lg text-gray-400 leading-relaxed mb-6 sm:mb-8">
            Our Nashville website management plans include everything needed to keep your site running smoothly — security, backups, updates, and more. Focus on your business while we handle the tech.
          </p>
        </div>

        <div className="bg-black border border-white/10 rounded-3xl p-6 sm:p-12">
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-6 sm:mb-8 text-center">
            Hosting and management includes:
          </h3>
          <div className="grid sm:grid-cols-2 gap-4 sm:gap-6">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start gap-3 sm:gap-4">
                <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center bg-white/10 rounded-full flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-base sm:text-lg"></i>
                </div>
                <p className="text-gray-300 text-base sm:text-lg">{feature}</p>
              </div>
            ))}
          </div>
          <p className="text-gray-400 leading-relaxed mt-8 sm:mt-10 text-center text-sm sm:text-base">
            This allows business owners to focus on running their business while we handle the technical details.
          </p>
        </div>
      </div>
    </section>
  );
}